<template>
  <section class="min-h-screen bg-background text-primary px-6 py-10">
    <div class="mx-auto max-w-4xl card-primary space-y-6">
      <h1 class="text-3xl font-bold text-gold">CGV</h1>
      <p class="text-sm text-secondary">Version: 2026-07-17</p>

      <div class="space-y-5 text-sm leading-6 text-secondary">
        <div>
          <h2 class="text-gold font-semibold">1. Vendeur</h2>
          <p>
            Les presentes CGV regissent les ventes realisees sur Quiestleplusriche,
            exploite par TEIXEIRA Philippe, micro-entreprise,
            SIREN 830751517, SIRET 83075151700020.
          </p>
          <p>TVA non applicable, article 293 B du Code general des impots.</p>
          <p>Contact: contact@quiestleplusriche.com</p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">2. Objet de la vente</h2>
          <p>
            Le service vendu correspond a l attribution de points de classement sur la plateforme,
            selon la regle 1 euro verse = 1 point credite.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">3. Prix</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Les prix sont exprimes en euros.</li>
            <li>Conformement au regime de micro-entreprise, la TVA n est pas appliquee.</li>
            <li>Le montant affiche avant paiement correspond au montant facture.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">4. Commande et paiement</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Le paiement est securise et traite via Stripe.</li>
            <li>Le credit de points intervient apres confirmation du paiement.</li>
            <li>Le systeme applique des controles techniques pour eviter les doubles credits.</li>
            <li>La commande est consideree comme ferme et definitive apres validation du paiement.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">5. Caractere non remboursable</h2>
          <p>
            Les achats de points sont definitifs et non remboursables,
            sauf disposition legale imperative contraire.
          </p>
          <p>
            Lors du paiement, l utilisateur confirme explicitement l acceptation des CGV
            et de la clause de non-remboursement.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">6. Preuve de la transaction et des consentements</h2>
          <p>
            Les enregistrements techniques, horodatages et confirmations de paiement,
            ainsi que les preuves d acceptation des CGV et versions associees,
            sont conserves comme elements de preuve.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">7. Responsabilite</h2>
          <p>
            Le vendeur ne saurait etre responsable des interruptions temporaires du service,
            indisponibilites techniques externes, ou incidents imputables a des tiers,
            notamment les prestataires de paiement.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">8. Droit de retractation</h2>
          <p>
            En validant la commande, l utilisateur reconnait que l execution du service
            commence immediatement apres confirmation du paiement.
            Pour les consommateurs, le droit de retractation de 14 jours peut ne pas s appliquer
            lorsque le service numerique est pleinement execute avant la fin de ce delai,
            apres demande expresse d execution immediate et renoncement explicite au droit de retractation.
          </p>
          <p>
            En validant son paiement, l utilisateur accepte l execution immediate du service
            et reconnait la perte de son droit de retractation, dans les conditions prevues
            par le Code de la consommation.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">9. Litiges et droit applicable</h2>
          <p>
            Les presentes CGV sont soumises au droit francais.
            En cas de litige, une tentative de resolution amiable est privilegiee.
          </p>
          <p>
            A defaut d accord amiable, competence est attribuee aux juridictions francaises
            dans les conditions prevues par la loi.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
